export default __webpack_public_path__ + "static/pycharm-cose-perche-sceglierlo-9c22c2960d7464a15c3c970d822f14ae.jpg";